import React from "react";
import { FormLabel, Input} from "@mui/joy";

const mappers = [
  {
    propname: "isActive",
    map: (value: boolean) => (value === true ? "Actief" : "Inactief"),
  },
];


export function labelValue(value:string, label:string)

{
  return (
    <>
        <FormLabel >{label} </FormLabel> 
        <Input 
        disabled={true}
          sx={{
    '--Input-focusedThickness': '0.1rem',
    '--Input-focusedHighlight': '#5b5fc7',
    '&::before': {
      transition: 'box-shadow .15s ease-in-out',
    },
    '&:focus-within': {
      borderColor: '#5b5fc7',
    },
    '&:focus-within::before': { boxShadow: 'var(--Input-focusedInset, inset) 0 0 0 calc(var(--Input-focused) * var(--Input-focusedThickness)) #5b5fc7' },
    "& .Mui-disabled": {
      color: "#000000 !important"
    }
  }} value={value ? value : ""}/>
    </>
    
  );
}

/**
 * @param milestone - The milestone object to retrieve the column value from.
 * @param column - The column object containing the property to retrieve from the milestone object.
 * @returns The value of the specified property in the milestone object, or an empty string if the property is undefined.
 */
export function getColumnValue(milestone: any, column: any) {
  if (!milestone || !column) return;
  const properties = column.property.split(".");
  let value = milestone;
  for (const property of properties) {
    if (property === "isActive" && typeof value[property] === "boolean") {
      value[property] = value[property] === true ? "Actief" : "Inactief";
    }
    if (property === "includeInMsTeam" && typeof value[property] === "boolean") {
      value[property] = value[property] === true ? "Ja" : "Nee";
    }
    value = value ? value[property] : undefined;
  }
  return value !== undefined ? value : "";
}
/**
 * Returns the value of a specific property of a milestone object.
 * @param milestone - The milestone object to retrieve the value from.
 * @param column - The column object containing the property to retrieve.
 * @returns The value of the specified property, or an empty string if it is undefined.
 */
export function getValue(milestone: any, column: any) {
  let value = milestone;
  value = value ? value[column.property] : undefined;
  return value !== undefined ? value : "";
}
export function formatDate(date: any) {
  if (typeof date === "string") {
    const dateRegex = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{1,3})?/i;
    const dateMatch = date.match(dateRegex);
    if (dateMatch) {

      const extractedDate = dateMatch[0];
      const dateObject = new Date(extractedDate);
      const formattedDate = dateObject.toLocaleDateString();
      return formattedDate;
    } else {
      return undefined;
    }

  }
  else return undefined;
}

export const convertToCurrencyLabel = (value: number): string => {
	if (value == null) { return ""; }
	return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value).replace(/\./g, ' ');
}
